export default __webpack_public_path__ + "static/media/S0020_6.14_MITT_algorithm.1702919280000.42de685d.jpg";